const breadCrumbStyle = {
  breadCrumbsWrapper: { marginBottom: 20 },
  breadCrumbIcon: { verticalAlign: "bottom", paddingBottom: 3, fontSize: 18 }
};

export default breadCrumbStyle;
